module.exports = __webpack_public_path__ + "static/media/eye2.ad48dec6.webp";